import { IndueCard } from "generated/generated-models";

export const getMaskedCardNumber = (card: IndueCard) => {
    const lastFourDigits = card.CardNumber?.substring(card.CardNumber?.length - 4) ?? "";
    const maskedCard = "•••• •••• •••• " + lastFourDigits;

    return maskedCard;
}
